import { combineReducers } from 'redux';

import loadXCardError from './loadXCardError';
import orderXCardError from './orderXCardError';
import recheckXCardStatusError from './recheckXCardStatusError';


export default combineReducers({
  loadXCardError,
  orderXCardError,
  recheckXCardStatusError,
});
